import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
#root {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
}
body {
  background-color: ${({ theme }) => theme.Bg1};
  color: ${({ theme }) => theme.text1};
}
.MuiDialog-root {
  margin-top: env(safe-area-inset-top);
  margin-bottom: env(safe-area-inset-bottom);
}
@media only screen and (max-width: 768px) {
  .MuiPopover-root .MuiPaper-root {
    max-height: calc(60% - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  }
}
.MuiDialog-root .MuiPaper-root, .MuiPopover-root .MuiPaper-root, .MuiPopper-root.MuiAutocomplete-popper .MuiPaper-root {
  background-color: ${({ theme }) => theme.modalBg1};
  color: ${({ theme }) => theme.text1};
  padding: 8px;
  font-size: 15px;
  box-sizing: border-box;
}
.MuiPopover-root .MuiPaper-root, .MuiPopper-root.MuiAutocomplete-popper .MuiPaper-root {
  border-radius: 12px;
}
.MuiPopper-root.MuiAutocomplete-popper .MuiPaper-root {
  .MuiAutocomplete-listbox {
    border-radius: 12px;
  }
}
.MuiDialog-root .MuiPaper-root {
  padding: 0px;
}
.MuiPopper-root .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused {
  background-color:  ${({ theme }) => theme.lightGray};
}
.MuiTooltip-tooltip {
  box-shadow: ${({ theme }) => theme.boxShadow1} !important;
  background-color: ${({ theme }) => theme.modalBg1} !important;
  color: ${({ theme }) => theme.text1} !important;
}
.MuiTooltip-popper .MuiTooltip-arrow {
  &::before {
    box-shadow: ${({ theme }) => theme.boxShadow1};
    background-color: ${({ theme }) => theme.modalBg1};
  }
}
.MuiChip-root.MuiChip-filled {
  background-color: ${({ theme }) => theme.lightGray};
}
.MuiChip-root.MuiChip-filled, .MuiChip-root.MuiChip-outlined {
  color: ${({ theme }) => theme.text1};
  .MuiChip-deleteIcon {
    color: ${({ theme }) => theme.mode === 'light' ? 'rgba(0, 0, 0, 0.26)' : 'rgba(255, 255, 255, 0.26)'};
    &:hover {
      color: ${({ theme }) => theme.fieldBorderHover1};
    }
  }
}
.MuiIconButton-root {
  &:hover {
    background-color: ${({ theme }) => theme.lightGray} !important;
  }
}
.MuiInputAdornment-root .MuiTypography-root {
  color: ${({ theme }) => theme.fieldText1};
}
.MuiDivider-root.MuiDivider-fullWidth, .MuiDivider-root.MuiDivider-vertical {
  border-color:  ${({ theme }) => theme.lightGray};
  color: ${({ theme }) => theme.fieldText1};
  &::before, &::after {
    border-color:  ${({ theme }) => theme.lightGray};
  }
}
.MuiButtonBase-root.MuiButton-text.Mui-disabled {
  color: ${({ theme }) => theme.tabText1};
}
.MuiList-root .MuiButtonBase-root {
  border-radius: 8px !important;
}
.MuiMenu-list {
  padding: 0 !important;
}
.MuiPagination-root.MuiPagination-text {
  .MuiPaginationItem-ellipsis {
    color: ${({ theme }) => theme.text1};
  }
  button {
    color: ${({ theme }) => theme.text1};
  }
  .Mui-selected {
    color: #E7E8EA;
  }
  .custom-dot {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 0.01071em;
    border-radius: 16px;
    text-align: center;
    box-sizing: border-box;
  }
}
.MuiSkeleton-root.MuiSkeleton-wave, .MuiSkeleton-root.MuiSkeleton-pulse {
  background-color: ${({ theme }) => theme.lightGray};
}
.MuiDrawer-root > .MuiPaper-root {
  height: 90%;
  background-color: ${({ theme }) => theme.modalBg1};
  overflow: hidden;
  // border-top-left-radius: 8px;
  // border-top-right-radius: 8px;
}
/* Start - toaster */
.toast-container {
  // width: max-content;
  min-height: auto;
  border-radius: 6px;
  margin-bottom: 6px;
}

.Toastify__toast-container--top-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.Toastify {
  @media only screen and (max-width: 480px) {
    .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
      top: var(--toastify-toast-top);
      left: 50%;
      transform: translateX(-50%);
      width: 98vw;
      // flex-direction: inherit;
    }
  }
}

.Toastify__progress-bar--wrp {
  height: 3px;
}

.Toastify__close-button {
  align-self: center;
  padding-left: 12px;
}

.Toastify__toast--success {
 border: 1px solid #99c69c;
 color: rgb(30, 70, 32);
 background-color: rgb(237, 247, 237);
}

.Toastify__toast--info {
  border: 1px solid #7faec4;
  color: rgb(1, 67, 97);
  background-color: rgb(229, 246, 253);
}

.Toastify__toast--warning {
  border: 1px solid #d8ba8f;
  color: rgb(102, 60, 0);
  background-color: rgb(255, 244, 229);
}

.Toastify__toast--error {
  border: 1px solid #df9291;
  color: rgb(95, 33, 32);
  background-color: rgb(253, 237, 237);
}

.view-post {
  font-size: 13px;
  text-decoration: underline;
}
/* End - toaster */

/* Start - Post Modal */
.post-close-icon {
  position: absolute;
  left: 24px;
  top: 12px;
}

.dialog-title {
  text-align: center;
  padding: 8px 24px !important;
  color: ${({ theme }) => theme.text1};
}

.MuiDialogContent-dividers {
  // border-top: 1px solid ${({ theme }) => theme.border1} !important;
}

.postModal {
  .MuiDialog-paper {
    width: 780px;
  }
  .ql-container {
    height: 200px;
  }
  @media only screen and (max-width: 500px) {
    .MuiDialog-paper {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
      max-height: 100%;
      min-height: 100%;
      margin: 0;
      top: 0;
    }
    .comment-container {
      width: 60% !important;
      .MuiInputBase-input {
        width: 75%
      }
    }
    .ql-container {
      height: 250px;
    }
  }
}

.commonModal {
  .MuiDialog-paper {
    width: 700px;
  }
  .ql-container {
    height: 200px;
  }
  @media only screen and (max-width: 500px) {
    .MuiDialog-paper {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
      max-height: 100%;
      min-height: 100%;
      margin: 0;
      top: 0;
    }
    .comment-container {
      width: 50% !important;
      .MuiInputBase-input {
        width: 75%
      }
    }
    .ql-container {
      height: 250px;
    }
  }
}

.reportModal {
  .MuiDialog-paper {
    width: 400px;
  }
}

.loginNotificationModal {
  .MuiDialog-paper {
    width: 500px;
    top: auto;
    height: auto;
  }
}

.uploadResumeModal {
  .MuiDialog-paper {
    width: 600px;
    top: 0;
    height: auto;
  }
  .dropzoneContainer {
    min-height: 120px !important;
  }
}

.searchModal {
  .MuiDialog-paper {
    top: 0;
    margin: 0;
    width: 650px;
    // transform: translateX(-77px);
    .MuiDialogContent-root {
      padding-bottom: 10px;
    }
  }
}

.search-highlight {
  text-decoration: underline;
}

.imgEditModal {
  .MuiDialog-paper {
    width: 700px;
    height: 86vh;
  }
  @media only screen and (max-width: 500px) {
    .MuiDialog-paper {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
      max-height: 100%;
      min-height: 100%;
      margin: 0;
      top: 0;
    }
    .comment-container {
      width: 50% !important;
      .MuiInputBase-input {
        width: 75%
      }
    }
    .ql-container {
      height: 250px;
    }
  }
}

.share-modal {
  .MuiDialog-paper {
    max-width: 98% !important;
  }
}

.job-template {
  .MuiDialog-paper {
    width: 700px;
    max-width: 700px;
    min-height: calc(100vh - 137px);
  }
  @media only screen and (max-width: 767px) {
    .MuiDialog-paper {
      margin-top: 0;
      top: 0px;
      min-height: 100vh;
    }
  }
}

.job-custom-template {
  .MuiDialog-paper {
    width: 700px;
    max-width: 700px;
    min-height: calc(100vh - 85px);
  }
  @media only screen and (max-width: 767px) {
    .MuiDialog-paper {
      margin-top: 0;
      top: 0px;
      min-height: 100vh;
    }
  }
}

.MuiDialog-paper {
  position: absolute !important;
  top: 10px;
  max-width: 100% !important;
}

.jobConfirm, .postDelete, .headerProfile, .reportModal {
  .MuiDialog-paper {
    top: auto;
    height: auto;
  }
}
.jobAppliedlist {
  .MuiDialog-paper {
    width: 98%;
    max-width: 1250px;
  }
}

.job-filter {
  .MuiPaper-root {
    height: 100% !important;
    width: 450px;
    @media only screen and (max-width: 500px) {
      width: calc(100% - 80px);
    }
  }
}

.job-alert {
  .MuiDialog-paper {
    max-width: 600px !important;
  }
}

.appstoreModal {
  .MuiDialog-paper {
    top: auto;
    height: auto;
    max-width: 900px !important;
  }
}

.ratings-modal {
  .MuiDialog-paper {
    width: 500px;
    max-width: 100%;
  }
}

.header-profile-popover .MuiPaper-root {
  max-height: 400px;
}

// Image Group
.ant-image-preview-mask {
  background-color: rgba(0, 0, 0, 0.9) !important;
}

.ant-image-preview-root, .ant-image-preview-operations-wrapper {
  position: fixed;
  z-index: 1400;
}

.comment-modal {
  .MuiPaper-root {
    width: 645px;
  }
}

// Document preview in full mode
.doc-preview-full-mode {
  .doc-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 98%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 2%;
    > button {
      margin-right: 20px;
      background-color: #E4E4E4;
      color: black;
    }
    .close-icon-container {
      path {
        fill: black;
      }
    }
  }
  .MuiPaper-root {
    top: 50px;
    max-width: none;
    box-shadow: none;
    margin: 0px;
    background-color: transparent;
  }
  .MuiDialogContent-root {
    padding: 0 !important;
  }
  .annotationLayer {
    max-width: 100%;
  }
  .react-pdf__Document {
    >div canvas {
      margin-bottom: 10px;
      max-width: 100%;
    }
    >div:last-child  canvas {
      margin-bottom: 0px;
    }
  }
  .react-pdf__Page {
    background: transparent !important;
  }
  .react-pdf__Page__textContent {
    display: none;
  }
  canvas {
    margin: 0 auto;
  }
}

// Field common styles
.labelContainer {
  display: flex;
  justify-content: space-between;
}

.lebelView {
  padding-bottom: 4px;
  label {
    font-size: 14px;
    font-weight: 500;
    padding: 8px 0 4px 0;
    color: ${({ theme }) => theme.fieldText1};
  }
}

.requiredSymbol {
  color: #d93025;
}

.errMsg {
  color: #d93025;
  display: flex;
  align-items: center;
  font-size: 13px;
  min-height: 20px;
  max-height: 40px;

  svg {
    min-width: 16px;
    min-height: 16px;
    max-width: 16px;
    max-height: 16px;
    margin-right: 4px;
    path {
      fill: #d93025;
    }
  }
}

// mui field style
.MuiInputBase-input {
  padding: 8px !important;
}

.MuiInputBase-input.Mui-disabled {
  opacity: 0.7 !important;
  -webkit-text-fill-color: inherit !important;
}

.MuiInputBase-root:not(.MuiInputBase-multiline) {
  height: 38px !important;
  padding-right: 0;
}

.MuiInputBase-multiline {
  padding: 0 !important;
}

.MuiOutlinedInput-root {
  font-size: 15px !important;
  color: ${({ theme }) => theme.text1} !important;
  .MuiSvgIcon-root {
    fill: ${({ theme }) => theme.svg1} !important;
  }
}

.MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-color: ${({ theme }) => theme.fieldBorder1};
}

.MuiInputBase-root.MuiOutlinedInput-root:not(.Mui-disabled) {
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.fieldBorderHover1};
  }
}

.MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: ${({ theme }) => theme.fieldBorder1};
  background-color: ${({ theme }) => theme.fieldDisable1};
}

.MuiButton-contained.Mui-disabled {
  color: ${({ theme }) => theme.disableText1} !important;
  background-color: ${({ theme }) => theme.disableBg1} !important;
}

.MuiButton-outlined.Mui-disabled {
  color: ${({ theme }) => theme.disableText1} !important;
  border: 1px solid ${({ theme }) => theme.disableBg1} !important;
}

.MuiMenuItem-root {
  &.Mui-selected {
    background-color: ${({ theme }) => theme.mode === 'light' ? 'rgba(25, 118, 210, 0.08)' : 'rgba(25, 118, 210, 0.2)'} !important;
  }
  &:hover {
    background-color: ${({ theme }) => theme.lightGrayHover} !important;
  }
}

// Upload
.dropzone-block {
  display: grid;
  position: relative;
  label {
    font-weight: 600;
    padding: 10px 0 4px 0;
  }
  .dropzoneContainer {
    border: 1px dashed ${({ theme }) => theme.fieldBorder1};
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    cursor: pointer;
    p {
      margin: 0;
      text-align: center;
    }
    h3 {
      margin: 0;
    }
  }
}

.dropzoneImgContainer {
  border: 2px dashed ${({ theme }) => theme.fieldBorder1};
  background-color: ${({ theme }) => theme.lightGray};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  cursor: pointer;

  .dropzone {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    padding: 15px;
  }
  .previewImg {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 120px;
    }
  }
}

.dropzone-highlight {
  border: 2px dashed green !important;
  background-color: #f4f4f4 !important;
}
.dropzone-disabled {
  opacity: 0.8;
  cursor: auto;
}

  .MuiButton-root.MuiButton-outlined.disabledbtn {
    border-color: ${({ theme }) => theme.disableBg1};
    color: ${({ theme }) => theme.disableBg1};
    background-color: ${({ theme }) => theme.mode === 'light' ? 'inherit' : 'rgba(0, 0, 0, 0.04)'};
    cursor: not-allowed;
  }
  .dropdown_menu {
    z-index: 1000 !important;
  }
  .dropzone-upload-text {
    color: #1976d2;
    text-decoration: underline;
  }

  //
  pre::-webkit-scrollbar {
    background: transparent;
    width: 10px;
  }

  pre::-webkit-scrollbar-thumb {
    background: #999;
  }

  .emoji {
    color: transparent;
    background-size: 16px 16px;
    background-position: center;
    background-repeat: no-repeat;
    vertical-align: middle;
    margin: 0 -1px;
  }
  .edit-info-container {
    position: relative;
    top: 4px;
    left: 8px;
  }
  /* tooltip */
  .edit-tooltip {
    .MuiTooltip-tooltip {
      padding: 12px;
      font-size: 14px;
      color: #333333;
      background-color: white;
      box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12);
      max-width: 180px;
      line-height: 1.5;
      z-index: 99;
    }
    .MuiTooltip-arrow {
      &::before {
        color: white;
        box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.2),0px 0px 0px 0px rgba(0,0,0,0.14),0px 0px 0px 0px rgba(0,0,0,0.12);
      }
    }
    .edit-count {
      padding-top: 8px;
    }
  }

  .select-menu-item {
    font-size: 15px !important;
  }
  .confirmModal {
    text-align: center;
    height: fit-content;
    .title {
      margin-top: 12px;
      font-size: 18px;
      font-weight: 600;
    }
    .sub-title {
      margin-top: 6px;
      font-size: 15px;
    }
    button {
      margin-top: 30px;
      margin-right: 16px;
    }
  }
  .network {
    .MuiDialog-paper {
      top: auto;
    }
    .confirmModal >div:first-child {
      text-align: center;
    }
    .sub-title {
      width: 80%;
      padding: 0 10%;
    }
  }
  .manage_message {
    .MuiDialog-paper {
      width: 700px;
      max-width: 100%;
    }
    .MuiDialogContent-root {
      padding-bottom: 0;
    }
  }
  /* Rich Text Editor */
  .rich-editor-description {
    word-break: break-all;
    overflow-wrap: anywhere;
    white-space: normal;
    ol {
      padding-left: 24px;
    }
  }
  .ql-snow {
    border-color: ${({ theme }) => theme.fieldBorder1} !important;
  }
  .ql-editor span.hashtag-blot {
    color: #08979c !important;
  }
  .ql-editor, .description-section {
    font-size: 15px !important;
    word-wrap: break-word;
    color: ${({ theme }) => theme.text1};
    @media only screen and (max-width: 500px) {
      font-size: 14px !important;
    }
    .mention-blot span {
      color: #1976d2 !important;
      font-weight: bold;
      user-select: none;
    }
    a {
      color: #007bff !important;
      background-color: transparent !important;
      &:visited {
        color: #800080 !important;
      }
      &:active {
        color: #ff0000 !important;
      }
    }
    code {
      background-color: ${({ theme }) => theme.lightGray} !important;
    }
    p {
      &:first-child {
        margin-top: 2px;
      }
      &:last-child {
        margin-bottom: 0px;
      }
      margin: 0px auto;
    }
    em {
      color: ${({ theme }) => theme.text1} !important;
    }
    span {
      background-color: transparent !important;
      color: ${({ theme }) => theme.text1} !important;
      word-wrap: break-word;
      word-break: break-word;
    }
    strong {
      font-weight: 600;
      background-color: transparent !important;
      color: ${({ theme }) => theme.text1};
    }
    h1, h2, h3, h4, h5, h6 {
      font-size: 15px !important;
      margin: 0;
    }
    .ql-syntax {
      background-color: ${({ theme }) => theme.mode === 'light' ? '#f1f1f1' : '#242424' }  !important;
      color: ${({ theme }) => theme.text1} !important;
      font-size: 14px;
      margin-bottom: 5px;
      margin-top: 5px;
      padding: 5px 10px;
      border-radius: 3px;
    }
    pre {
      word-wrap: break-word;    
      overflow-wrap: break-word;
      word-break: break-word;   
      white-space: normal;
    }
    .ql-align-center {
      text-align: center;
    }
    .ql-align-right {
      text-align: right;
    }
    ul, ol {
      margin: 0;
    }
  }
  .no-data-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 0 80px 0;
    color: #c4c4c4;
    font-weight: 600;
    font-size: 20px;
    svg {
      width: 130px;
      height: 130px;
      margin-bottom: 10px;
    }
    >div {
      text-align: center;
    }
  }

  @media only screen and (max-width: 500px) {
    .MuiDialogContent-root {
      padding: 12px !important;
    }
    .MuiDialog-paper {
      top: auto;
    }
    .MuiDialogTitle-root {
      padding: 8px !important;
    }
    .post-close-icon {
      left: 12px;
      top: 10px;
    }
    .custom-job-steps {
      display: none !important;
    }
    .job-form-title {
      margin-top: 0 !important;
    }
    .job-img-wrap {
      > div:nth-child(2) {
        width: 60% !important;
      }
      > div:nth-child(1) {
        width: 35% !important;
      }
    }
    .comment-modal {
      .MuiPaper-root {
        width: 98%;
        height: 100%;
        margin: 0;
      }
    }
    .settings-styles {
      height: 82.6vh;
    }
    .job-alert {
      .MuiDialog-paper {
        max-width: 95%;
        min-width: 95%;
        width: 95%;
        max-height: 90%;
        min-height: 90%;
        margin: 0;
        top: 5%;
      }
    }
    /* header */
    // &:not(.hidden){
    //   .segmented-tab > div:first-child {
    //     transition: top 0.7s;
    //     top: 55px;
    //   }
    // }
    .hidden {
      ~.LayoutContainer {
        .segmented-tab > div:first-child, .post-back {
          // transition: top 0.7s;
          // top: 0px;
        }
      }
      // top: -55px;
    }
    .header-brand {
      margin-left: 8px;
    }
    .header-container {
      .head-list {
        .MuiButtonBase-root, .header-user-name-block {
          display: none;
        }
      }
      .profile-container {
        padding: 0;
        background-color: transparent;
      }
    }
    .head-list {
      position: absolute;
      right: 10px;
      min-width: auto !important;
    }
    /* Job Filter and Alert */
    .job-filter-btn {
      margin-left: 4px !important;
    }
    .follow-user-activity {
      display: none !important;
      // > div:nth-child(2) {
      //   width: auto;
      // }
      // > div {
      //   width: 48% !important;
      // }
    }
    .follow-img-container {
      > svg ~ div {
        >div:nth-child(3), >div:nth-child(4) {
          left: 65% !important;
        }
        >div:nth-child(5), >div:nth-child(6) {
          display: none;
        }
      }
    }
    .network-no-data-found {
      height: 71.2vh !important;
      padding-top: 30px !important;
    }
    .MuiMenuItem-root {
      min-height: 30px !important;
      font-size: 14px !important;
      span {
        min-height: 30px !important;
      }
    }
  }
  @media only screen and (max-width: 450px) {
    .setting-info-container {
      .setting-menu {
        > div:nth-child(2) > div {
          max-width: 100px;
        }
      }
    }
  }
  
  // Image Edit
  .FIE_topbar-buttons-wrapper,
  .FIE_topbar-back-button,
  .FIE_topbar-center-options, 
  .FIE_text-size-option ~ div ~ div,
  .FIE_annotation-option-triggerer,
  .FIE_topbar-reset-button {
    display: none !important;
  }

  .FIE_topbar {
    padding: 0px;
    padding-bottom: 8px;
    display: flex;
    justify-content: flex-end;
  }

  .FIE_canvas-container {
    padding: 0px;
    padding-top: 8px;
  }

  .FIE_tabs {
    display: none;
  }

  .FIE_tab {
    width: 55px;
    min-height: 55px;
    margin-top: 8px;
    svg {
      color: #757675;
    }
  }

  .FIE_canvas-node > div {
    min-height: 450px !important;
  }

  .FIE_annotation-controls-overlay {
    transform: translateX(-100%);
    > button:first-child {
      display: none !important;
    }
  }

  .FIE_filters-items {
    li  {
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(5) {
        display: none !important;
      }
    }
  }

  .FIE_tools-items {
    li  {
      &:nth-child(5),
      &:nth-child(8) {
        display: none !important;
      }
    }
  }
`;

export default GlobalStyle;
